<template>
  <div class="AIdetails" v-if="serviceInfo">
    <div class="header">
      <div class="title">
        <span
          @click="back"
          style="cursor: pointer; color: #4587ff; margin-right: 20px"
          ><i class="el-icon-arrow-left"></i>返回</span
        >
        专业服务购买
      </div>
    </div>
    <div class="banner">
      <div class="title_box">
        <div class="title">
          {{ serviceInfo.name || '加载中...' }}
        </div>
      </div>
      <div class="name">
        执业人员：<span @click="ResumeClick()">{{ serviceInfo.userName }}</span>
      </div>

      <div>
        <div
          class="length"
          style="margin-bottom: 15px"
          @click="
            show_project = true
            isSpecs = false
          "
        >
          <span class="must"
            >项目：
            <span
              v-if="!projectName"
              style="color: #326afb; font-weight: normal"
              >请选择</span
            >
            <span v-else style="font-weight: normal"> {{ projectName }} </span>
          </span>
        </div>
        <div class="length" style="margin-bottom: 15px" @click="openSpecs()">
          <span class="must"
            >流程：
            <span
              v-if="specsArr.length == 0"
              style="color: #326afb; font-weight: normal"
              >请选择</span
            >
            <div v-for="(item, index) in specsArr" :key="index">
              <span
                class="select_label"
                v-if="specsArr.length > 0 && index < 5"
                >{{ item.specsName }}</span
              >
              <span
                class="select_label"
                style="width: 20px"
                v-if="specsArr.length > 0 && index == 5"
                >...</span
              >
            </div>
          </span>
        </div>
      </div>

      <div class="pase">
        <div class="box">
          <div>
            <span class="mory" style="margin-right: 15px">
              <span style="font-size: 15px">￥</span>
              {{ specsPrice }}
            </span>
          </div>
          <span class="img">
            <img
              :src="
                imgUrl + 'group1/M00/12/1E/L2pUHWR3QBqAZ81VAAAbKuyKg4M354.png'
              "
              mode=""
            />
          </span>
        </div>
        <div class="" style="display: flex; align-items: center">
          <img
            style="width: 15px; height: 15px"
            :src="wqUrl + 'retention_money2.png'"
            mode=""
          />
          <span
            style="color: #326afb; font-size: 15px; margin-left: 7px"
            @click.stop="marginPop = true"
            >质保金</span
          >
        </div>
      </div>
      <div>
        <div class="text_area" style="margin-bottom: 15px">
          <span class="must">填写相关要求</span>
          <textarea
            v-model="requireText"
            auto-height
            placeholder="请填写服务相关要求"
          />
        </div>
        <div class="select_box_up">
          <div class="tit_sel">
            <div class="" style="">上传相关资料</div>
            <div
              @click="$refs.files.click()"
              class=""
              style="display: flex; align-items: center"
            >
              <span style="margin: 0 0 0 5px; color: #326afb">上传</span>
            </div>
          </div>
          <div class="item_sel" v-for="(el, i) in taskFiles" :key="i">
            <div class="" style="">
              <span style="color: #333; margin-right: 5px">{{ i + 1 }}.</span>
              {{ el.fileName }}
            </div>
            <!-- <u-icon name="close" color="#666" @click="deUpword(i)"></u-icon> -->
          </div>
        </div>
        <div class="text_area">
          <span class="must">联系方式</span>
          <textarea
            v-model="contactText"
            auto-height
            style="height: 15px"
            placeholder="请输入联系方式"
          />
          <!-- <input type="text" placeholder="请输入联系方式" style="margin-top: 15px;"> -->
        </div>
      </div>

      <div
        class="prompt_warn"
        v-if="serviceInfo.isElectronContract"
        @click="openContract"
      >
        购买此类服务需要签订<span
          style="color: #6a93ff"
          @click.stop="downFile(serviceInfo.contractTemplateExampleUrl)"
          >《{{ serviceInfo.contractTemplateName }}》</span
        >
        <span style="color: #326afb; margin-left: 15px">点击填写信息</span>
      </div>

      <div class="btn_box_gm clickText" @click="goshopp">
        <div class="goshopp">开始下单</div>
      </div>

      <div class="food_bd">
        <div
          class="tabs_box"
          style="position: sticky; background: #fff; z-index: 99"
        >
          <el-tabs v-model="active" @tab-click="onTabs">
            <el-tab-pane label="简介" name="0"></el-tab-pane>
            <el-tab-pane :label="`用户评论( ${numb})`" name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div
          style="padding: 15px; box-sizing: border-box"
          class=""
          v-show="active === 0"
        >
          {{ serviceInfo.brief }}
        </div>
        <div class="" v-show="active === 1">
          <div class="statistics_box" @click="goUserRate()">
            <div style="display: flex">
              <el-rate
                :value="serviceInfo.star"
                disabled
                show-score
                text-color="#ff9900"
              ></el-rate>

              <span style="margin-left: 15px"
                >{{ serviceInfo.star || 0 }}星,共5星</span
              >
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div v-if="dataList.length > 0">
            <div class="comment" v-for="(el, i) in dataList" :key="i">
              <div class="xingxing">
                <u-rate
                  :value="el.star"
                  active-color="#f6b529"
                  readonly
                  size="19px"
                />
              </div>
              <span>{{ el.content }}</span>
              <div class="plderen_box">
                <div class="" style="display: flex; align-items: center">
                  <div class="toux">
                    <img :src="el.headImg" mode="" />
                  </div>
                  <span class="name_pld">
                    {{ el.nickName }}
                  </span>
                </div>
                <div class="time">
                  {{ el.createTime }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="isLack" style="margin-top: 115px">
            <el-empty
              width="95px"
              height="95px"
              description="没有找到数据"
              image="https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/all_page_nullTowImg.png"
            ></el-empty>
          </div>
          <u-loadmore
            v-if="!isLack && !isProcess"
            nomoreText="没有更多数据了"
            :status="loadStatus"
          />
          <div class="" style="height: 1px"></div>

          <div
            v-if="isProcess"
            style="
              margin-top: 115px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              style="width: 150px"
              :src="wqUrl + 'loadingImg.gif'"
              mode="widthFix"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="项目选择" :visible.sync="show_project" width="30%">
      <div class="project_box">
        <div v-if="!isSpecs">
          <div class="title_box">
            <span>项目选择 <span class="label">单选</span></span>
            <div class="close" @click="show_project = false"></div>
          </div>
          <div class="select_box">
            <div
              :class="['select_item', proXz === index ? 'pro_xz' : '']"
              v-for="(item, index) in projectList"
              :key="index"
              @click="proXz = index"
            >
              {{ item.projectName }}
            </div>
          </div>
          <div
            class="confirm_btn"
            @click="
              show_project = false
              getServicesProjectSpecs()
            "
          >
            确认
          </div>
        </div>
        <div v-else>
          <div class="title_box">
            <div style="display: flex">
              流程选择
              <div class="label">
                （可多选，点击
                <div class="" style="display: inline-div"></div>
                可查看流程详情）
              </div>
            </div>
          </div>
          <div class="select_box">
            <div
              :class="['select_item', item.selected === true ? 'pro_xz' : '']"
              v-for="(item, index) in specsList"
              :key="index"
              @click="selectSpecs(item)"
            >
              <div style="display: flex; align-items: center">
                <div style="margin-right: 15px">{{ `流程${index + 1}` }}</div>
                <span>{{ item.specsName }}</span>
                <div
                  style="margin-left: 5px; padding: 2px 5px"
                  @click.stop=";(show_pop1 = true), (specsItem = item)"
                ></div>
              </div>
              <span style="color: #eb441e; font-weight: bold"
                >￥{{ item.price }}</span
              >
            </div>
          </div>
          <div class="confirm_btn" @click="confirmSpecs()">确认</div>
        </div>
      </div>
    </el-dialog>
    <!-- 扫码支付 -->
    <el-dialog title="扫码支付" :visible.sync="payVisible" class="payment">
      <div class="content">
        <div class="notes">请使用微信扫码下方二维码完成支付</div>
        <div class="imgBox">
          <img :src="payimg" alt="" />
        </div>
      </div>
    </el-dialog>
    <!-- 保证金规则 -->
    <div class="popup" v-if="marginPop">
      <div class="margin_box">
        <img
          :src="imgUrl + 'group1/M00/12/39/L2rchmR4HOmAY9pAAACylwPvKjQ493.png'"
          mode=""
        />
        <span class="h1">质量保证金规则</span>
        <span class="cont_box"
          >为提升保障服务质量，客户支付总额的5%，作为质量保证金。根据用户评级扣减质量保证金。规则如下：</span
        >
        <div class="guizhe_hezhi">
          <div
            class="juti_guizhe"
            v-for="(it, i) in [1, 2, 3, 4, 5, 6]"
            :key="i"
          >
            <div class="dian"></div>
            {{ i }}星
            <div class="" style="margin-left: 15px">
              <el-rate :value="i" active-color="#f6b529" readonly size="19px" />
            </div>
            <div
              v-if="i !== 5"
              class=""
              style="color: #999999; margin-left: 20px"
            >
              扣减
              <span style="color: #326afb; margin-left: 5px">{{ 5 - i }}%</span>
            </div>
            <div v-else class="" style="color: #326afb; margin-left: 20px">
              不扣减
            </div>
          </div>
        </div>
        <div class="anl_box clickText" @click="marginPop = false">
          <img
            :src="
              imgUrl + 'group1/M00/12/1F/L2pUHWR4OXKAEjCJAAADHjGyMvY590.png'
            "
            mode=""
          />
          我已知悉
        </div>
      </div>
    </div>
    <!-- 上传资料 -->
    <input
      type="file"
      style="display: none"
      @change="doRealUpload"
      ref="files"
    />
    <!-- <u-popup
      :show="isInfo"
      @close="isInfo = false"
      round="20"
      closeable
      :closeOnClickOverlay="false"
    >
      <div style="height: 65vh" class="infoClass">
        <div class="infoTitle">请填写以下信息:</div>
        <div class="info_item">
          <div class="left_info"><span style="color: red">*</span> 类型：</div>
          <div class="right_info">
            <u-radio-group
              v-model="partyA.type"
              shape="circle"
              @change="radioGroupChange"
            >
              <u-radio label="个人" :name="1"></u-radio>
              <u-radio
                label="公司"
                :name="2"
                @change="radioChange"
                :customStyle="{ marginLeft: '15px' }"
              ></u-radio>
            </u-radio-group>
          </div>
        </div>
        <div
          class="info_item"
          :style="{ display: partyA.type == 1 ? '' : 'div' }"
        >
          <div
            class="left_info"
            :style="{ marginBottom: partyA.type == 1 ? '0' : '15px' }"
          >
            <span style="color: red">*</span
            >{{ partyA.type == 1 ? '姓名' : '公司名称' }}(甲方)：
          </div>
          <input
            type="text"
            v-model="partyA.name"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item" style="display: div">
          <div class="left_info" style="margin-bottom: 15px">
            <span style="color: red">*</span
            >{{ partyA.type == 1 ? '身份证号' : '统一社会信用代码' }}：
          </div>
          <input
            type="text"
            v-model="partyA.idCardNumber"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item">
          <div class="left_info"><span style="color: red">*</span>住所地：</div>
          <input
            type="text"
            v-model="partyA.address"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item">
          <div class="left_info">
            <span style="color: red">*</span>收件地址：
          </div>
          <input
            type="text"
            v-model="partyA.shippingAddress"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item">
          <div class="left_info"><span style="color: red">*</span>联系人：</div>
          <input
            type="text"
            v-model="partyA.contacts"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item">
          <div class="left_info">
            <span style="color: red">*</span>联系电话：
          </div>
          <input
            type="text"
            v-model="partyA.telephone"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item">
          <div class="left_info"><span style="color: red">*</span>微信号：</div>
          <input
            type="text"
            v-model="partyA.weChat"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item">
          <div class="left_info"><span style="color: red">*</span>E-mail：</div>
          <input
            type="text"
            v-model="partyA.email"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item">
          <div class="left_info"><span style="color: red">*</span>相对人：</div>
          <input
            type="text"
            v-model="partyA.counterparty"
            class="right_info"
            placeholder="请输入..."
          />
        </div>
        <div class="info_item" v-if="partyA.type === 1">
          <div class="left_info">
            <span style="color: red">*</span>甲方签字：
          </div>
          <div class="right_info" @click="isSignature = true">
            <span v-if="!partyA.signature" style="color: #326afb"
              >点击签名</span
            >
            <img v-else :src="partyA.signature" mode="" class="qmImg" />
          </div>
        </div>
        <div class="info_item" v-if="partyA.type === 2">
          <div class="left_info">
            <span style="color: red">*</span>甲方公司印章：
          </div>
          <div class="right_info" @click="selectCard()">
            <span v-if="!partyA.signature" style="color: #326afb"
              >点击上传公司印章</span
            >
            <img
              v-else
              :src="partyA.signature"
              mode=""
              style="width: 150px; height: 75px"
            />
          </div>
        </div>

        <div class="but_box">
          <div class="" @click="isInfo = false">确定</div>
          <div class="qux" @click="isInfo = false">取消</div>
        </div>
      </div>
    </u-popup> -->
  </div>
</template>

<script>
import {
  servicesInfo,
  servicesProject,
  servicesProjectSpecs,
  servicesBuy,
  findCommentsByTarget,
  queryATaskUserEnterInfo,
  ossUpload,
  orderPayment,
  payOrderQuery,
} from 'api/professionServer'
import qs from 'qs'

export default {
  props: ['serviceId', 'type'],
  data() {
    return {
      // 支付弹框
      payVisible: false,
      // 支付扫码图片
      payimg: '',
      showdialog: false,
      numb: 0,
      xienumb: 2,
      active: 0,
      bailChek: true, // 质保金是否选择
      info: [],
      current: 0,
      mode: 'dot',
      imgUrl: 'https://fafs.antiplagiarize.com/', // 图片url
      wqUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/', // 图片url

      optXZ: 0, // 选中的规格
      marginPop: false,
      page: 1,
      total: 0,
      dataList: [],
      show_pop: false,
      tabsHei: 0,
      serviceInfo: {},

      show_project: false, //规格弹框
      proXz: -1, //选中规格
      projectName: '',
      projectList: [], //规格列表
      isSpecs: false, //是否选择流程
      specsList: [], //流程列表
      specsPrice: 0, //已选流程总价格
      specsArr: [], //已选的流程
      requireText: '', //相关要求
      contactText: '', //联系方式
      taskFiles: [], //已上传的资料文件
      show_pop1: false,
      specsItem: {},
      isInfo: false, // 信息弹窗
      partyA: {
        // 甲方合同信息
        type: 1,
        name: '',
        idCardNumber: '',
        address: '',
        shippingAddress: '',
        contacts: '',
        telephone: '',
        weChat: '',
        email: '',
        counterparty: '',
        signature: '',
      },
      loadStatus: 'loading',
      isLack: false,
      isProcess: true, // 初始数据加载
    }
  },
  watch: {
    serviceId(v) {
      this.servicesInfo()
    },
  },
  async created() {
    this.servicesInfo()
  },
  methods: {
    async servicesInfo() {
      let res = await servicesInfo(
        qs.stringify({
          serviceId: this.serviceId,
        })
      )
      if (res.code !== 200) return
      this.serviceInfo = res.data
      this.getServicesProject()
    },

    // 上传
    async doRealUpload(e) {
      let file = e.target.files[0]
      // this.fileList.push(file.name)
      // console.log(this.fileList)
      let form = new FormData()
      form.append('file', file)
      const res = await ossUpload(form)
      if (res.code === 200) {
        this.taskFiles.push({
          fileName: file.name,
          filePath: res.data,
        })
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }

      // console.log(res);
    },
    // 验证实名认证
    openContract() {
      let userInfo = JSON.parse(localStorage.getItem('userinfo'))
      if (userInfo.authenticationStatus !== 1 || !userInfo.hasIdcardNumberImg) {
        this.isPractice = false
        // this.$refs.cDialog.displayFun({
        //   title: '提示',
        //   message: `${
        //     userInfo.authenticationStatus !== 1
        //       ? '选择该类型需要先实名认证'
        //       : userInfo.authenticationStatus == 1 &&
        //         !userInfo.hasIdcardNumberImg
        //       ? '已实名认证,请补充身份证正反面'
        //       : ''
        //   }`,
        //   confirmTxt: `${
        //     userInfo.authenticationStatus !== 1
        //       ? '去实名'
        //       : userInfo.authenticationStatus == 1 &&
        //         !userInfo.hasIdcardNumberImg
        //       ? '去补充'
        //       : ''
        //   }`,
        //   confirm: () => {
        //     if (userInfo.authenticationStatus !== 1) {
        //     } else if (
        //       userInfo.authenticationStatus == 1 &&
        //       !userInfo.hasIdcardNumberImg
        //     ) {
        //     }
        //   },
        // })
        return
      }
      this.queryATaskUserEnterInfo()
      this.isInfo = true
    },
    // 甲方信息回显
    async queryATaskUserEnterInfo() {
      let res = await queryATaskUserEnterInfo({
        type: this.partyA.type,
      })
      if (res.code !== 200) return
      if (!res.data) {
        this.partyA.name = ''
        this.partyA.idCardNumber = ''
        this.partyA.address = ''
        this.partyA.contacts = ''
        this.partyA.shippingAddress = ''
        this.partyA.telephone = ''
        this.partyA.weChat = ''
        this.partyA.email = ''
        this.partyA.counterparty = ''
        this.partyA.signature = ''
        return
      }
      this.partyA.name = res.data.name
      this.partyA.idCardNumber = res.data.idCardNumber
      this.partyA.address = res.data.address
      this.partyA.contacts = res.data.contacts
      this.partyA.shippingAddress = res.data.shippingAddress
      this.partyA.telephone = res.data.telephone
      this.partyA.weChat = res.data.weChat
      this.partyA.email = res.data.email
      this.partyA.counterparty = res.data.counterparty
      this.partyA.signature = res.data.signature
      this.partyA = {
        ...this.partyA,
      }
    },
    // 公司需要企业认证
    radioGroupChange(e) {
      this.queryATaskUserEnterInfo()
      if (e === 2) {
        let userInfo = JSON.parse(localStorage.getItem('userinfo'))
        if (
          userInfo.enterpriseSuthenticationStatus === 0 ||
          userInfo.enterpriseSuthenticationStatus === 3
        ) {
          this.isInfo = false
          //   this.$refs.cDialog.displayFun({
          //     title: '提示',
          //     message: `${
          //       userInfo.enterpriseSuthenticationStatus === 0
          //         ? '选择该类型需要先企业认证'
          //         : '企业认证未通过，请重新认证'
          //     }`,
          //     confirmTxt: '去认证',
          //     confirm: () => {},
          //     cancel: () => {
          //       this.isInfo = true
          //     },
          //   })

          return
        } else if (userInfo.enterpriseSuthenticationStatus === 1) {
          this.$message.success('企业认证审核中')
        }
      }
    },

    // 关闭小语介绍弹窗
    closePop() {
      this.show_pop = false
    },
    ResumeClick(val) {
      //   if (val) {
      //     return
      //   }
      //   if (this.type == 1) {
      //   } else {
      //   }
    },
    // 开始下单
    goshopp() {
      if (this.serviceInfo.isElectronContract) {
        let is = false
        Object.keys(this.partyA).forEach((el) => {
          if (!this.partyA[el]) {
            is = true
          }
        })
        if (is) {
          this.$message.error(`请将${this.serviceInfo.name}合同信息填写完整`)

          return
        }
      }

      if (this.specsArr.length <= 0) {
        this.$message.error(`请选择服务流程`)

        return
      }
      if (this.requireText.length <= 0) {
        this.$message.error(`请填写相关要求`)

        return
      }
      if (this.contactText.length <= 0) {
        this.$message.error(`请填写联系方式`)

        return
      }
      this.servicesBuy()
    },
    // 返回
    back() {
      this.$emit('back')
    },
    change(e) {
      this.current = e.detail.current
    },
    onTabs(e) {
      this.active = e.index
      this.dataList = []
      this.isProcess = true
      this.isLack = false
      this.page = 1
      if (e.index == 1) {
        this.findCommentsByTarget()
      }
    },
    deUpword(i) {
      this.taskFiles.splice(i, 1)
    },
    confirmSpecs() {
      this.specsArr = this.specsList.filter((el) => {
        return el.selected == true
      })
      let price = 0
      this.specsArr.forEach((val) => {
        price += val.price
      })
      this.specsPrice = price
      this.show_project = false
    },
    // 已选流程
    selectSpecs(val) {
      val.selected = !val.selected
      this.specsList = [...this.specsList]
    },
    // 去详情
    dataClick(v) {},
    commentClick(v) {},
    // 购买专业服务
    async servicesBuy() {
      //流程id数组
      let arr = []
      this.specsArr.forEach((el) => {
        arr.push(el.id)
      })
      let data = {
        contactInfo: this.contactText,
        remark: '',
        serviceId: Number(this.serviceId),
        servicesProjectId: this.projectList[this.proXz].id,
        servicesSpecsIds: arr,
        taskFiles: this.taskFiles,
        taskName: this.serviceInfo.name,
        taskRequire: this.requireText,
      }
      data.partyA = {
        ...this.partyA,
      }
      let res = await servicesBuy(data)
      if (res.code !== 200) return this.$message.error(res.data)
      this.$confirm('下单成功是否支付', '提示', {
        confirmButtonText: '支付',
        cancelButtonText: '稍后支付',
        type: 'warning',
      })
        .then(() => {
          this.orderPayment(res.data, true)
        })
        .catch(() => {})
    },
    // 支付
    async orderPayment(orderId) {
      let opt = {
        applicationTpye: this.$store.state.publicType,
        openId: '',
        orderId: orderId,
        wayCode: 'WX_NATIVE',
      }

      let res = await orderPayment(opt)
      if (res.code !== 200) return
      this.payVisible = true
      this.payimg = res.data.payData
      this.payOrderQuery(res.data.payOrderId)
      let timer = setInterval(() => {
        this.payOrderQuery(res.data.payOrderId, timer)
      }, 3000)
    },
    // 订单支付状态查询
    async payOrderQuery(id, timer) {
      let res = await payOrderQuery({
        payOrderId: id,
      })
      if (res.code !== 200) return
      clearInterval(timer)
      this.payVisible = false
      this.$confirm('支付成功，是否前往我的任务', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$bus.$emit('getuserinfo', 1)
        })
        .catch(() => {
          this.back()
        })
    },
    // 选择流程
    async openSpecs() {
      if (this.proXz == -1) {
        this.$message.error('请选择规格')

        return
      }
      this.isSpecs = true
      this.show_project = true
    },
    async getServicesProjectSpecs() {
      if (this.proXz == -1) return
      this.projectName = this.projectList[this.proXz].projectName
      let res = await servicesProjectSpecs(
        qs.stringify({
          projectId: this.projectList[this.proXz].id,
        })
      )
      if (res.code !== 200) return
      this.specsList = res.data
      this.specsList.map((el) => {
        el.selected = false
      })
    },
    async getServicesProject() {
      let res = await servicesProject(
        qs.stringify({
          serviceId: this.serviceId,
        })
      )
      if (res.code !== 200) return
      this.projectList = res.data
    },
    // 关注产品
    async collectClick(val) {
      //   let res = await productAttention({
      //     caseId: val.id,
      //   })
      //   if (res.code !== 200) return
      //   let tip
      //   if (val.isAttention == 0) {
      //     val.isAttention = 1
      //     tip = '收藏成功'
      //   } else {
      //     val.isAttention = 0
      //     tip = '取消收藏'
      //   }
      //   this.$message.error(tip)
    },
    // 获取评论
    async findCommentsByTarget() {
      let opt = {
        limit: 10,
        page: this.page,
        type: 5,
      }
      let res = await findCommentsByTarget(JSON.stringify(opt))
      if (res.code !== 200) {
        this.isLack = true
        this.isProcess = false
        if (this.page > 1) this.page -= 1
        return
      }
      this.isProcess = false
      this.dataList = [...this.dataList, ...res.data.data]
      if (this.dataList.length < 1) {
        this.isLack = true
      }
      if (this.dataList.length === res.data.total) {
        this.loadStatus = 'nomore'
      }
      this.total = res.data.total
    },
    // 去用户评级
    goUserRate(id) {
      //   if (this.type == 1 && !id) {
      //   } else {
      //     if (id) {
      //     } else {
      //     }
      //   }
    },

    // 上传文件

    downFile(path) {},
  },
}
</script>

<style lang="scss" scoped>
.AIdetails {
  width: 100%;
  height: 770px;
  overflow-y: auto;
  box-sizing: border-box;
  position: relative;

  .banner {
    width: 100%;
    background-color: #fff;
    .title_box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        margin: 15px 0;
      }
    }

    .name {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: 15px;

      span {
        color: #326afb;
      }
    }

    .food_bd {
      box-sizing: border-box;
      padding-bottom: calc(constant(safe-area-inset-bottom));
      padding-bottom: calc(env(safe-area-inset-bottom));
    }

    .btn_box_gm {
      width: 100%;
      height: 50px;
      margin: 30px 0 15px;
      border-radius: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(to left, #326afb, #d6293a);

      .goshopp {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #ffffff;
      }
    }

    .length {
      width: 100%;
      height: 42px;
      background: #f6f8fc;
      border-radius: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      box-sizing: border-box;
      color: #333333;
      font-size: 15px;
      font-weight: bold;
    }

    .select_label {
      display: inline-div;
      font-size: 11px;
      font-weight: normal;
      margin-right: 5px;
      max-width: 115px;
      height: 15px;
      background: #cddbff;
      border-radius: 5px;
      padding: 0 5px;
      box-sizing: border-box;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transform: translateY(3px);
    }

    .must {
      // position: relative;
      display: flex;
      align-items: center;
      &::before {
        content: '*';
        color: #eb3828;
        font-size: 15px;
        font-weight: bold;
        margin-right: 7px;
      }
    }

    .text_area {
      width: 100%;
      background: #f7f8fa;
      border-radius: 15px;
      padding: 15px 15px;
      box-sizing: border-box;
      font-size: 15px;
      color: #333;
      font-weight: bold;

      textarea {
        width: 100%;
        min-height: 33px;
        max-height: 130px;
        margin-top: 15px;
        background: #f7f8fa;
        box-sizing: border-box;
        line-height: 20px;
        font-weight: normal;
      }
    }

    .pase {
      margin: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .mory {
        font-size: 23px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #eb441e;
      }

      .img {
        width: 71px;
        height: 19px;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.39);

    .margin_box {
      width: 379px;
      height: 435px;
      padding-bottom: 20px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;

      > img {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: -1;
      }

      .h1 {
        font-size: 16px;
        font-weight: bold;
        color: #326afb;
        margin-top: 33px;
      }

      .cont_box {
        width: 227px;
        font-size: 11px;
        color: #333333;
        line-height: 22px;
        margin-top: 19px;
      }

      .guizhe_hezhi {
        width: 300px;
        height: 410px;
        background: #ffffff;
        box-shadow: 0px 3px 9px 1px rgba(88, 133, 215, 0.19);
        border-radius: 10px;
        margin-top: 19px;

        .juti_guizhe {
          width: 100%;
          padding: 0 12px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-top: 13px;

          .dian {
            width: 5px;
            height: 5px;
            background: #cadfff;
            border-radius: 50%;
            margin-right: 15px;
          }
        }
      }

      .anl_box {
        width: 298px;
        height: 60px;
        background: linear-gradient(-90deg, #326afb, #80a3ff);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-weight: 600;
        margin-top: 20px;

        > img {
          width: 15px;
          height: 15px;
          margin-right: 10px;
        }
      }
    }
  }
}

.statistics_box {
  width: 100%;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  background: #f4f7ff;
  margin-top: 15px;
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}

.comment {
  padding: 12px 15px 12px;
  border-bottom: 2px solid #fbfbfb;

  .xingxing {
    margin-bottom: 23px;
  }

  > text {
    font-size: 13px;
    color: #626262;
  }

  .plderen_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 21px;

    .toux {
      width: 24px;
      height: 12px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #999999;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    .name_pld {
      margin-left: 15px;
      font-size: 12px;
      font-weight: bold;
      color: #4e4e4e;
      display: flex;
      align-items: center;
    }

    .time {
      font-size: 11px;
      color: #999999;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  margin-top: 15px;

  .headimg {
    width: 58px;
    height: 58px;
    border-radius: 50%;
  }

  .text {
    flex: 1;
    padding-left: 10px;

    .tops {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;

      .boxs {
        width: 40px;
        height: 19px;
        margin-left: 15px;
        background: #f5f8ff;
        border: 1px solid #7ca1ff;
        border-radius: 3px;
        font-size: 12px;
        color: #4d7efc;
        line-height: 19px;
        text-align: center;
      }
    }

    .boot {
      display: flex;
      align-items: center;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;

      span {
        color: #999999;
        margin-left: 15px;
      }
    }
  }

  .more {
    img {
      width: 16px;
      height: 16px;
    }
  }
}

.project_box {
  padding: 15px;

  .title_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    color: #000000;
    margin-bottom: 20px;

    .label {
      font-size: 12px;
      color: #999999;
      margin-left: 15px;
    }
  }

  .select_box {
    min-height: 178px;
    max-height: 350px;
    overflow-y: scroll;
    width: 100%;
    margin-bottom: 40px;

    .select_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 39px;
      background: #f6f6f6;
      border-radius: 5px;
      line-height: 39px;
      padding: 0 15px;
      margin: 15px 0;
      box-sizing: border-box;
      font-size: 13px;
      color: #666;
    }
  }

  .confirm_btn {
    margin: 20px auto;

    width: 345px;
    height: 40px;
    background: #326afb;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }

  .pro_xz {
    color: #000000 !important;
    border: 1px solid #326afb;
  }
}

.select_box_up {
  width: 100%;
  min-height: 50px;
  background: #f7f8fa;
  border-radius: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  margin-bottom: 15px;
  border-bottom: 1px solid transparent;

  > div {
    width: 100%;
    min-height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tit_sel {
    > div:first-child {
      font-weight: 600;
      font-size: 15px;
      color: #666666;
    }
  }

  .item_sel {
    min-height: 40px;
    margin-bottom: 15px;

    > div:first-child {
      font-size: 15px;
      color: #326afb;
    }

    > div:last-child {
      font-size: 15px;
      color: #333333;
      display: flex;
      align-items: center;
      font-weight: 600;

      > img {
        width: 15px;
        height: 15px;
      }
    }
  }
}

.prompt_warn {
  color: #f9ae3d;
  background-color: #fdf6ec;
  padding: 15px 12px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
  font-size: 13px;
  margin: 15px 0;
}

.infoClass {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  color: #333;
  overflow: auto;

  .infoTitle {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .info_item {
    width: 100%;
    margin-top: 5px;
    padding: 12px 0px;
    box-sizing: border-box;
    border-bottom: 1px solid #dadbde;
    display: flex;
    align-items: center;

    > input {
      flex: 1;
    }
  }

  .left_info {
    font-size: 15px;
    min-width: 220px;

    > text {
      margin-right: 5px;
      font-weight: 600;
    }
  }

  .right_info {
    font-size: 15px;
  }
}

.but_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  > div {
    width: 48%;
    height: 40px;
    background-color: #326afb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
  }

  .qux {
    background-color: #ececec;
    color: #333;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  .tit_box {
    font-size: 16px;
    font-weight: bold;
    color: #000000;

    display: flex;
    align-items: center;
    justify-content: space-between;
    .tip {
      font-size: 12px;
      font-weight: normal;
      color: #333;
      > text {
        color: #326afb;
      }
    }
  }
  .title {
    position: relative;
    font-size: 16px;
    width: 100%;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #333333;
    .el-button {
      position: absolute;
      top: -10px;
      right: 0;
    }
  }
  .more {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
  }
}
.qmImg {
  width: 150px;
  transform: rotate(-90deg);
}
// 支付弹窗
.payment {
  ::v-deep .el-dialog {
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
    width: 500px;
    height: 390px;
    background: #ffffff;
    border: 0px solid #818790;
    box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
    .el-dialog__header {
      height: 42px;
      background: #f4f6f7;
      padding: 0;
      line-height: 42px;
      .el-dialog__title {
        margin-left: 15px;
        font-size: $font-size-medium;
        font-family: PingFang SC;
        font-weight: 500;
        color: #393939;
      }
      .el-dialog__headerbtn {
        top: $font-size-small;
        right: $font-size-small;
        font-size: $font-size-large;
      }
    }
    .el-dialog__body {
      padding: 65px 20px;
      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .notes {
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: 500;
          color: $color-text-black;
        }
        .imgBox {
          width: 110px;
          height: 110px;
          margin-top: 30px;
          img {
            width: 110px;
            height: 110px;
          }
        }
      }
    }
  }
}
</style>
